<template>
  <div>
    <div class="row">
      <div class="planos">
        <div class="card-plano">
          <div
            class="card-header position-relative text-uppercase font-weight-bold text-center fs-22"
          >
            <label class="checktainer c-pointer m-0">
              <input
                type="radio"
                name="plano"
                class="plano-checkbox"
                value="3"
                v-model="Fields.paymentPlan"
                @input="ErrorMessages.paymentPlan = null"
                required
              />
              Plano
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="card-body">
            <div class="fs-20 text-center text-uppercase">4,0% da venda</div>
            <div class="fs-14 text-center p-4px">pela Plataforma</div>
          </div>
          <div class="card-footer p-5px">
            <div
              class="w-100 c-pointer btn btn-aceitar-contrato"
              @click="showContratoPlano('contrato-lojista-plano-pagamento')"
            >
              Ver e aceitar o contrato
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <p
          class="error-message text-danger col-5"
          v-if="ErrorMessages.paymentPlan !== null"
        >
          {{ ErrorMessages.paymentPlan }}
        </p>
      </div>
      <ShopKeeperPaymentPlan />
      <div class="col-12 mt-3" v-if="Fields.segmentos !== []">
        <div class="form-group">
          <label for="segmentos"> Segmentos da loja </label>
          <div class="m-0 p-0 mb-2">
            (Adicione o(s) segmento(s) que deseja receber seus orçamentos)
            <hr />
          </div>
          <!-- <p class="error-message text-danger" v-if="ErrorMessages.companyName !== null">
           {{ ErrorMessages.companyName }}
          </p> -->
          <div class="row col-12" id="segmentos">
            <div
              class="col-3 pb-20px"
              v-for="(segments, index) in Fields.segmentos"
              :key="index"
            >
              <div class="btn-remove" @click="removeSegmentoLojista(index)">
                <i class="fas fa-times"></i>
              </div>
              <v-select
                id="segmento"
                class="w-100"
                v-model="Fields.segmentos[index]"
                label="nome"
                :reduce="(segment) => segment.id"
                :options="segmentos"
                @input="ErrorMessages.segmentos = null"
                placeholder="Selecione um segmento para a loja"
              >
                <div slot="no-options">Não encontrou nada.</div>
              </v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="c-pointer" @click="addSegmentoLojista()">
                <div class="btn-plus d-inline">
                  <i class="fas fa-plus c-orange"></i>
                </div>
                <div class="fs-15 d-inline-block p-left-10px">Segmento</div>
              </div>
            </div>
            <div>
              <p
                class="error-message text-danger"
                v-if="ErrorMessages.segmentos !== null"
              >
                {{ ErrorMessages.segmentos }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label for="cadastroRazaoSocial"> Razão Social </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.razao_social"
            id="cadastroRazaoSocial"
            aria-describedby="Razão Social para cadastro da empresa"
            placeholder="Digite a razão social da empresa"
            @input="ErrorMessages.companyName = null"
            required
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.companyName !== null"
          >
            {{ ErrorMessages.companyName }}
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="cadastroNomeFantasia"> Nome Fantasia </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.nome_fantasia"
            id="cadastroNomeFantasia"
            aria-describedby="Nome Fantasia para cadastro da empresa"
            placeholder="Digite o nome fantasia da empresa"
            required
            @input="ErrorMessages.fantasyName = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.fantasyName !== null"
          >
            {{ ErrorMessages.fantasyName }}
          </p>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label for="cadastroNomeResponsavel"> Nome Responsável </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.nome_responsavel"
            id="cadastroNomeResponsavel"
            aria-describedby="Nome do Responsável para cadastro da empresa"
            placeholder="Digite o nome do Responsável da empresa"
            required
            @input="ErrorMessages.responsibleName = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.responsibleName !== null"
          >
            {{ ErrorMessages.responsibleName }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroCnpj"> CNPJ </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.cnpj"
            id="cadastroCnpj"
            v-mask="'##.###.###/####-##'"
            aria-describedby="CNPJ para cadastro da empresa"
            placeholder="Digite o CNPJ da empresa"
            required
            @input="ErrorMessages.cnpj = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cnpj !== null"
          >
            {{ ErrorMessages.cnpj }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroCelular"> Celular / Whatsapp </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.celular"
            id="cadastroCelular"
            v-mask="['(##) #####-####', '(##) ####-####']"
            aria-describedby="Celular para cadastro da empresa"
            placeholder="Digite o celular da empresa"
            required
            @input="ErrorMessages.cellPhone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cellPhone !== null"
          >
            {{ ErrorMessages.cellPhone }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroTelefone"> Telefone </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.telefone"
            id="cadastroTelefone"
            v-mask="'(##) ####-####'"
            aria-describedby="Telefone para cadastro da empresa"
            placeholder="Digite o telefone da empresa"
            required
            @input="ErrorMessages.telephone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone !== null"
          >
            {{ ErrorMessages.telephone }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroTelefone"> Telefone 2 </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.telefone2"
            id="cadastroTelefone2"
            v-mask="['(##) ####-####', '(##) #####-####']"
            aria-describedby="Telefone para cadastro da empresa"
            placeholder="Digite o telefone 2 da empresa"
            @input="ErrorMessages.telephone2 = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone2 !== null"
          >
            {{ ErrorMessages.telephone2 }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="cadastroCep"> CEP </label>
        <input
          type="text"
          class="form-control"
          v-model="Fields.cep"
          id="cadastroCep"
          v-mask="'#####-###'"
          aria-describedby="CEP para cadastro da empresa"
          placeholder="Digite o CEP da empresa"
          required
          @input="ErrorMessages.cep = null"
        />
        <p class="error-message text-danger" v-if="ErrorMessages.cep !== null">
          {{ ErrorMessages.cep }}
        </p>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label for="cadastroEndereco"> Endereço </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.endereco"
            id="cadastroEndereco"
            aria-describedby="Endereço para cadastro da empresa"
            placeholder="Digite o endereço da empresa"
            @input="ErrorMessages.address = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidAddress)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.address !== null"
          >
            {{ ErrorMessages.address }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="cadastroNumero"> Número </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.numero"
            id="cadastroNumero"
            aria-describedby="Número para cadastro da empresa"
            placeholder="Digite o número da empresa"
            @input="ErrorMessages.number = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number !== null"
          >
            {{ ErrorMessages.number }}
          </p>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label for="cadastroComplemento"> Complemento </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.complemento"
            id="cadastroComplemento"
            aria-describedby="Complemento para cadastro da empresa"
            placeholder="Digite o complemento da empresa"
            @input="ErrorMessages.complement = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.complement !== null"
          >
            {{ ErrorMessages.complement }}
          </p>
        </div>
      </div>
      <div class="col-md-4"></div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <div class="form-group">
          <label for="cadastroBairro"> Bairro </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.bairro"
            id="cadastroBairro"
            aria-describedby="Bairro para cadastro da empresa"
            placeholder="Digite o bairro da empresa"
            @input="ErrorMessages.neighborhood = null"
            required
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidNeighborhood)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.neighborhood !== null"
          >
            {{ ErrorMessages.neighborhood }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cidade_id"> Cidade </label>
          <v-select
            disabled
            id="cidade_id"
            name="cidade_id"
            label="nome"
            placeholder="Selecione a cidade da empresa"
            autocomplete="nope"
            class="no-search"
            v-model="Fields.cidade_id"
            :key="Fields.cidade_id"
            :options="getCities"
            :reduce="(city) => city.id"
            @input="ErrorMessages.city = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.city !== null"
          >
            {{ ErrorMessages.city }}
          </p>
        </div>
      </div>
      <!-- <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cadastroEstado">
            UF
          </label>
          <v-select
            id="cadastroEstado"
            v-model="Fields.uf"
            label="uf"
            :options="estados"
            placeholder="Selecione o estado da empresa"
            autocomplete="nope"
            @input="ErrorMessages.uf = null"
            required
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p class="error-message text-danger" v-if="ErrorMessages.uf !== null">
           {{ ErrorMessages.uf }}
          </p>
        </div>
      </div> -->
    </div>
    <div class="row">
      <div class="col-12">
        <hr />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <h3>Contato do financeiro</h3>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroNomeFinanceiro"> Nome do Responsável </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.nome_financeiro"
            id="cadastroNomeFinanceiro"
            aria-describedby="Nome do responsável do financeiro para cadastro da empresa"
            placeholder="Digite o nome do responsável do financeiro da empresa"
            @input="ErrorMessages.name_financial = null"
            required
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.name_financial !== null"
          >
            {{ ErrorMessages.name_financial }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroEmailFinanceiro"> Email do Responsável </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.email_financeiro"
            id="cadastroEmailFinanceiro"
            aria-describedby="Email do responsável do financeiro para cadastro da empresa"
            placeholder="Digite o e-mail do responsável do financeiro da empresa"
            @input="ErrorMessages.email_financial = null"
            required
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email_financial !== null"
          >
            {{ ErrorMessages.email_financial }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroNumeroFinanceiro"> Telefone / Celular </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.numero_financeiro"
            id="cadastroNumeroFinanceiro"
            v-mask="['(##) ####-####', '(##) #####-####']"
            aria-describedby="Número do responsável do financeiro para cadastro da empresa"
            placeholder="Digite o número do responsável do financeiro da empresa"
            @input="ErrorMessages.number_financial = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number_financial !== null"
          >
            {{ ErrorMessages.number_financial }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroRamalFinanceiro"> Ramal </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.ramal_financeiro"
            id="cadastroRamalFinanceiro"
            aria-describedby="Ramal do responsável do financeiro para cadastro da empresa"
            placeholder="Digite o ramal do responsável do financeiro da empresa"
            @input="ErrorMessages.ramal_financial = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.ramal_financial !== null"
          >
            {{ ErrorMessages.ramal_financial }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <hr />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-lg-6 mb-lg-0 mb-2">
        <div class="form-group">
          <label for="cadastroEmailLojista"> Email do Lojista </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.email"
            id="cadastroEmailLojista"
            placeholder="Digite o email que o lojista pretende receber as cotações"
            @input="ErrorMessages.email = null"
            required
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email !== null"
          >
            {{ ErrorMessages.email }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <div class="mb-3">
          <b-form-checkbox
            id="termoConfirmacao"
            name="termoConfirmacao"
            v-model="acceptedTermsAndConditions"
            @input="ErrorMessages.confirmationTerm = null"
            required
          >
            Li e aceito os termos e condições.
            <span class="c-orange c-pointer" v-b-modal="'termos'"
              >Ver termos</span
            >
          </b-form-checkbox>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.confirmationTerm !== null"
          >
            {{ ErrorMessages.confirmationTerm }}
          </p>
          <b-form-checkbox
            id="politicaPrivacidade"
            name="politicaPrivacidade"
            v-model="acceptedPrivacyPolicy"
            @input="ErrorMessages.privacyPolicy = null"
            required
          >
            Li e aceito a política de privacidade.
            <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'"
              >Ver termos</span
            >
          </b-form-checkbox>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.privacyPolicy !== null"
          >
            {{ ErrorMessages.privacyPolicy }}
          </p>
        </div>
        <div class="form-group">
          <button
            type="submit"
            class="btn bg-orange c-white text-uppercase"
            @click="register()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
    <!-- Termos e Condições -->
    <TermsAndConditions />
    <!-- Política de Privacidade -->
    <PrivacyPolicy />
    <!-- Contrato Lojista Plano 1 -->
    <ShopkeeperContractPlan1 />
    <!-- Contrato Lojista Plano 2 -->
    <ShopkeeperContractPlan2 />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ShopkeeperContractPlan1 from '../../components/ShopkeeperContractPlan1.vue';
import ShopkeeperContractPlan2 from '../../components/ShopkeeperContractPlan2.vue';
import UserTypes from '../../enums/UserTypes';
import PaymentMethods from '../../enums/AffiliatePaymentMethods';
import TermsAndConditions from '../../components/TermsAndConditions.vue';
import PrivacyPolicy from '../../components/PrivacyPolicy.vue';
import makeToast from '../../mixins/makeToast';
import ShopKeeperPaymentPlan from '../../components/PaymentPlanContract.vue';

export default {
  mixins: [makeToast],
  components: {
    ShopKeeperPaymentPlan,
    ShopkeeperContractPlan1,
    ShopkeeperContractPlan2,
    TermsAndConditions,
    PrivacyPolicy,
  },
  data() {
    return {
      UserTypes,
      PaymentMethods,
      acceptedPrivacyPolicy: false,
      acceptedTermsAndConditions: false,
      Fields: {
        paymentPlan: '',
        segmentos: [],
        razao_social: '',
        nome_fantasia: '',
        nome_responsavel: '',
        cnpj: '',
        celular: '',
        telefone: '',
        telefone2: '',
        endereco: '',
        numero: '',
        complemento: '',
        cep: '',
        bairro: '',
        cidade_id: null,
        uf: 25,
        nome_financeiro: '',
        email_financeiro: '',
        numero_financeiro: '',
        ramal_financeiro: '',
        email: '',
        data_vencimento: null,
      },
      ErrorMessages: {
        segmentos: null,
        companyName: null,
        fantasyName: null,
        responsibleName: null,
        cnpj: null,
        cellPhone: null,
        telephone: null,
        telephone2: null,
        address: null,
        number: null,
        complement: null,
        cep: null,
        neighborhood: null,
        city: null,
        uf: null,
        name_financial: null,
        email_financial: null,
        number_financial: null,
        ramal_financial: null,
        payment_type: null,
        email: null,
        confirmationTerm: null,
        privacyPolicy: null,
        paymentPlan: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
    };
  },
  mounted() {
    this.getAllCities();
  },
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification', 'getBaseUri']),
    ...mapGetters('general', ['getCities']),
    ...mapState(['estados', 'cidades', 'planos', 'segmentos', 'dadosUsuario']),
  },
  watch: {
    'Fields.cep': function () {
      this.consultCep();
    },
  },
  created() {
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadPlanos');
    this.$store.dispatch('loadSegmentos');
  },
  methods: {
    ...mapActions('general', ['getAllCities']),
    addSegmentoLojista() {
      this.Fields.segmentos.push({});
    },
    removeSegmentoLojista(index) {
      this.Fields.segmentos.splice(index, 1);
    },
    showContratoPlano(idPlano) {
      this.$bvModal.show(idPlano);
    },
    hideContratoPlano(idPlano) {
      this.$bvModal.hide(idPlano);
    },
    register() {
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');

        Object.assign(this.Fields, { id: this.dadosUsuario.informacoes.id });

        this.$store
          .dispatch('affiliate/registerShopkeeper', this.Fields)
          .then((response) => {
            this.makeToast('Sucesso!', response.data.message);

            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => this.$store.dispatch('endLoader'));
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    consultCep() {
      if (this.Fields.cep.length === 9) {
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.Fields.cep)
          .then(async (response) => {
            this.validateCepResults(response.data);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => this.$store.dispatch('endLoader'));
      }

      if (this.Fields.cep.length === 0) {
        this.cepConsult.consulted = false;
        this.Fields.endereco = null;
        this.Fields.bairro = null;
        this.Fields.cidade_id = null;
      }
    },
    validateFields() {
      let isValid = true;

      if (!this.$validate.name(this.Fields.razao_social)) {
        this.ErrorMessages.companyName = 'Razão inválida';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_fantasia)) {
        this.ErrorMessages.fantasyName = 'Nome Fantasia inválido';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_responsavel)) {
        this.ErrorMessages.responsibleName = 'Nome do Responsavel inválido';
        isValid = false;
      }

      if (!this.$validate.cnpj(this.Fields.cnpj)) {
        this.ErrorMessages.cnpj = 'CNPJ inválido';
        isValid = false;
      }

      if (!this.$validate.address(this.Fields.endereco)) {
        this.ErrorMessages.address = 'Endereço inválido';
        isValid = false;
      }

      if (!this.$validate.neighborhood(this.Fields.bairro)) {
        this.ErrorMessages.neighborhood = 'Bairro inválido';
        isValid = false;
      }

      if (!this.$validate.cep(this.Fields.cep)) {
        this.ErrorMessages.cep = 'CEP inválido';
        isValid = false;
      }

      if (this.Fields.cidade_id === null) {
        this.ErrorMessages.city = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.Fields.paymentPlan === '') {
        this.ErrorMessages.paymentPlan =
          'Você não selecionou o plano de pagamento';
        isValid = false;
      }

      if (!this.Fields.segmentos || this.Fields.segmentos.length === 0) {
        this.ErrorMessages.segmentos = 'Você não selecionou nenhum segmento';
        isValid = false;
      }

      if (this.Fields.uf === null) {
        this.ErrorMessages.uf = 'Você não selecionou nenhum estado';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_financeiro)) {
        this.ErrorMessages.name_financial = 'Nome inválido';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email_financeiro)) {
        this.ErrorMessages.email_financial = 'Email de Financeiro inválido';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email)) {
        this.ErrorMessages.email = 'Email inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.celular)) {
        this.ErrorMessages.cellPhone = 'Celular inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.telefone)) {
        this.ErrorMessages.telephone = 'Telefone inválido';
        isValid = false;
      }

      if (!this.acceptedPrivacyPolicy) {
        this.ErrorMessages.privacyPolicy =
          'Você precisa aceitar a política de privacidade';
        isValid = false;
      }

      if (!this.acceptedTermsAndConditions) {
        this.ErrorMessages.confirmationTerm =
          'Você precisa aceitar os termos e condições';
        isValid = false;
      }

      // Campos não Obrigatorios

      if (
        this.Fields.numero !== null &&
        this.Fields.numero !== '' &&
        !this.$validate.addressNumber(this.Fields.numero)
      ) {
        this.ErrorMessages.number = 'Número inválido';
        isValid = false;
      }

      if (
        this.Fields.telefone2 !== null &&
        this.Fields.telefone2 !== '' &&
        !this.$validate.telephone(this.Fields.telefone2)
      ) {
        this.ErrorMessages.telephone2 = 'Telefone 2 inválido';
        isValid = false;
      }

      if (
        this.Fields.numero_financeiro !== null &&
        this.Fields.numero_financeiro !== '' &&
        !this.$validate.telephone(this.Fields.numero_financeiro)
      ) {
        this.ErrorMessages.number_financial = 'Numero do Financeiro inválido';
        isValid = false;
      }

      return isValid;
    },
    validateCepResults(result) {
      this.cepConsult.consulted = true;

      this.cepConsult.isValidAddress = !!result.logradouro;

      this.cepConsult.isValidNeighborhood = !!result.bairro;

      this.Fields.endereco = result.logradouro || null;
      this.Fields.bairro = result.bairro || null;
      this.Fields.cidade_id = result.cidade_id || null;

      this.ErrorMessages.address = null;
      this.ErrorMessages.neighborhood = null;
      this.ErrorMessages.city_id = null;
    },
  },
};
</script>

<style scoped>
@import '../../custom/css/cadastro.css';

div.form-group label {
  font-weight: 700;
}

.no-search .vs_search {
  background: transparent;
}
</style>
